<div class="pagination d-flex justify-content-center">
  <ngb-pagination
    [(page)]="page!"
    [pageSize]="pageSize ?? 10"
    [collectionSize]="pagination?.total ?? 0"
    [maxSize]="1"
    (pageChange)="onPageChange($event)"
    [ellipses]="false"
    class="d-flex justify-content-center">
    <ng-template ngbPaginationPrevious>
      <div class="pagination-arrow-wrapper">
        <nb-icon class="pagination-icons" icon="arrow-left" pack="icomoon"></nb-icon>
      </div>
    </ng-template>
    <ng-template ngbPaginationNext>
      <div class="pagination-arrow-wrapper">
        <nb-icon class="pagination-icons" icon="arrow-right" pack="icomoon"></nb-icon>
      </div>
    </ng-template>
    <ng-template ngbPaginationNumber let-page>
      <div class="page-active-number">
        <input appOnlyNumbersInput [formControl]="inputControl" />
      </div>
      <div class="page-numbers" (click)="redirectToLastPage($event)">
        {{ currentPanelLang === 'en' ? 'of' : ('view_translations.out_of' | translate )}} {{ convertToNumber(pagination?.total_pages?.toFixed(0) ?? '0') < 1 ? 1
        : pagination?.total_pages?.toFixed(0) }}
      </div>
    </ng-template>
  </ngb-pagination>
</div>
